import { trailingSlashesPattern, validBaseUrl } from '../constants';
export var getUrlPath = function (url, baseUrl) {
    if (url === void 0) { url = ''; }
    if (baseUrl === void 0) { baseUrl = ''; }
    try {
        if (baseUrl && url.startsWith(baseUrl)) {
            url = url.replace(baseUrl, '');
        }
        var urlPath = new URL(url, validBaseUrl).pathname.replace(trailingSlashesPattern, '');
        if (urlPath) {
            var decodedUrl = decodeURIComponent(urlPath);
            return decodedUrl.replace(trailingSlashesPattern, '');
        }
        else {
            return '';
        }
    }
    catch (_a) {
        return '';
    }
};
//# sourceMappingURL=get-url-path.js.map